var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { } from '@angular/core';
import { HubPlace } from '../../../models/hub/hub.place';
import { HubApiService } from '../../../services/hub.api.service';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { AlertifyService } from '../../../services/alertify.service';
import { PlaceService } from '../../../services/place.service';
import { ToggleAndDataSourceStore } from '../../../stores/hub.calendar.store';
import { ConfirmModalActions, ConfirmModalData } from '../../../common/components/confirm.modal/confirm.modal.provider';
import { ModalService } from '../../../common/services/modal.service';
import { ConfirmModalComponent } from '../../../common/components/confirm.modal/confirm.modal.component';
import { clone } from '../../../common/extensions';
import { config } from '../../../../config/config';
import { InputModalComponent } from "../../../common/components/input.modal/input.modal.component";
import { InputModalActions, InputModalData } from "../../../common/components/input.modal/input.modal.provider";
import { EditManuallyPlaceImagesModalActions } from './edit.manually.place.images.modal.provider';
var EditManuallyPlaceImagesModalComponent = /** @class */ (function (_super) {
    __extends(EditManuallyPlaceImagesModalComponent, _super);
    function EditManuallyPlaceImagesModalComponent(dialogRef, actions, hubApiService, imageService, alertify, modalService, toggleAndDataSourceStore, data) {
        var _this = _super.call(this) || this;
        _this.dialogRef = dialogRef;
        _this.actions = actions;
        _this.hubApiService = hubApiService;
        _this.imageService = imageService;
        _this.alertify = alertify;
        _this.modalService = modalService;
        _this.toggleAndDataSourceStore = toggleAndDataSourceStore;
        _this.isPlaceInfoLoaded = false;
        _this.isDragging = false;
        _this.dragFrom = '';
        _this.dropTargets = [];
        _this.coverImage = '';
        _this.publishedImages = [];
        _this.compensateForPublished = [];
        _this.compensateForAvailable = [];
        _this.ownedImages = [];
        _this.compensateForOwned = [];
        _this.googleKey = '';
        _this.totalImageCount = 10;
        _this.totalImageCountThatSysAdminSet = 10;
        _this.useFirstImgAsCover = true;
        _this.place = Object.assign({}, data);
        _this.hubName = _this.place.hubName;
        _this.toggleAndDataSourceStore.toggleAndDataSourceCommand
            .takeUntil(_this.isDestroyed)
            .subscribe(function (command) {
            if (command && command.dataSource.placeImagesShownCount) {
                _this.totalImageCountThatSysAdminSet = command.dataSource.placeImagesShownCount;
            }
            _this.getPlaceAdditionalData();
        });
        return _this;
    }
    EditManuallyPlaceImagesModalComponent.prototype.getPlaceAdditionalData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.buildImages();
                this.compensate();
                this.isPlaceInfoLoaded = true;
                return [2 /*return*/];
            });
        });
    };
    EditManuallyPlaceImagesModalComponent.prototype.confirm = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var actions, data;
            return __generator(this, function (_a) {
                if (!this.publishedImages.length) {
                    event.immediateComplete();
                    this.alertify.warning('Please select at least one allowed image');
                    return [2 /*return*/];
                }
                actions = {
                    confirm: function (e) { return __awaiter(_this, void 0, void 0, function () {
                        var _a;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    e.complete();
                                    if (!this.place.cover)
                                        this.place.cover = { source: '', isDefault: false };
                                    this.coverImage = this.publishedImages[0];
                                    this.place.allowedGooglePhotos = this.publishedImages;
                                    return [4 /*yield*/, this.uploadOwnedImagesToAWS()];
                                case 1:
                                    _b.sent();
                                    if (this.ownedImages && this.ownedImages.any(function (img) { return img.status === 'failed'; })) {
                                        event.immediateComplete();
                                        return [2 /*return*/];
                                    }
                                    this.place.ownedPhotos = this.ownedImages.map(function (x) { return x.url; });
                                    _a = this.ownedImages.any(function (x) { return x.status === 'uploaded'; });
                                    if (!_a) return [3 /*break*/, 3];
                                    return [4 /*yield*/, this.myWait(1000)];
                                case 2:
                                    _a = (_b.sent());
                                    _b.label = 3;
                                case 3:
                                    _a;
                                    event.immediateComplete();
                                    this.actions.confirm(e, this.place, this.coverImage);
                                    this.dialogRef.close();
                                    return [2 /*return*/];
                            }
                        });
                    }); },
                    cancel: function () {
                        event.immediateComplete();
                    }
                };
                data = {
                    confirmModalIcon: 'warning',
                    confirmModalTitle: 'Alert',
                    confirmModalDescription: 'Please note that any images uploaded or used in ' +
                        'this software must either be royalty-free or owned by the client. By uploading or using an image, you ' +
                        'acknowledge that you have the necessary rights to use it and that you will be solely responsible for any ' +
                        'copyright infringement or other legal issues that may arise from the use of the image. We strongly advise our ' +
                        'users to exercise due diligence and ensure that they have the necessary rights to use any images uploaded or ' +
                        'used in this software.',
                    confirmModalConfirmButtonText: 'Yes',
                    confirmModalCancelButtonText: 'Cancel',
                    isAsync: true,
                };
                this.modalService.show({
                    component: ConfirmModalComponent,
                    providers: [
                        { provide: ConfirmModalActions, useValue: actions },
                        { provide: ConfirmModalData, useValue: data },
                    ],
                });
                return [2 /*return*/];
            });
        });
    };
    EditManuallyPlaceImagesModalComponent.prototype.uploadOwnedImagesToAWS = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _loop_1, this_1, _i, _a, img;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _loop_1 = function (img) {
                            var res;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (img.url.includes('amazonaws'))
                                            return [2 /*return*/, "continue"];
                                        img.status = 'uploading';
                                        return [4 /*yield*/, this_1.hubApiService.uploadBase64ImageToAWS(img.url, config.compressImgWidth, 'places/iti-user-upload/')];
                                    case 1:
                                        res = _a.sent();
                                        if (res.success) {
                                            img.url = res.url;
                                            img.status = 'uploaded';
                                            setTimeout(function () {
                                                img.status = 'done';
                                            }, 3000);
                                        }
                                        else {
                                            img.status = 'failed';
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _i = 0, _a = this.ownedImages;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        img = _a[_i];
                        return [5 /*yield**/, _loop_1(img)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    EditManuallyPlaceImagesModalComponent.prototype.removeOwnImage = function (index) {
        this.ownedImages.splice(index, 1);
    };
    EditManuallyPlaceImagesModalComponent.prototype.getImage = function (imgUrl, isRealReference) {
        if (isRealReference === void 0) { isRealReference = true; }
        if (imgUrl.startsWith('http') || imgUrl.startsWith('data:')) {
            return imgUrl;
        }
        var url = PlaceService.getGooglePlaceImageFullUrl(imgUrl, this.googleKey, isRealReference);
        return this.imageService.imageSourceUrl(url);
    };
    EditManuallyPlaceImagesModalComponent.prototype.dragEnter = function ($event) {
        if ($event && $event.currentTarget) {
            this.restoreItemStyle();
            $event.currentTarget.style.border = '2px dashed green';
            if (!this.dropTargets.any(function (x) { return x === $event.currentTarget; })) {
                this.dropTargets.push($event.currentTarget);
            }
        }
    };
    EditManuallyPlaceImagesModalComponent.prototype.startDrag = function ($event, from) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.isWaitingForUpload($event.srcElement.currentSrc))
                    return [2 /*return*/];
                if (!this.isDragging) {
                    this.isDragging = true;
                    this.dragFrom = from;
                }
                return [2 /*return*/];
            });
        });
    };
    EditManuallyPlaceImagesModalComponent.prototype.onItemDrop = function (e, to, index) {
        if (index === void 0) { index = -1; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var photoReference_1, dragDataIndex, temp, temp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.restoreItemStyle();
                        if (!(this.dragFrom === 'owned')) return [3 /*break*/, 2];
                        if (!this.ownedImages.any(function (x) { return _this.isWaitingForUpload(x.url); })) return [3 /*break*/, 2];
                        this.alertify.warning('Please wait for uploading, and move the image again.');
                        return [4 /*yield*/, this.uploadOwnedImagesToAWS()];
                    case 1:
                        _a.sent();
                        this.isDragging = false;
                        return [2 /*return*/];
                    case 2:
                        if (e.dragData) {
                            photoReference_1 = PlaceService.getGooglePlaceReference(e.dragData);
                            if (this.dragFrom === 'allowed' && to === 'allowed') {
                                if (index === -1) {
                                    this.isDragging = false;
                                    return [2 /*return*/];
                                }
                                dragDataIndex = this.publishedImages.indexOf(photoReference_1);
                                temp = this.publishedImages[index];
                                this.publishedImages[index] = photoReference_1;
                                this.publishedImages[dragDataIndex] = temp;
                            }
                            if (this.dragFrom === 'owned' && to === 'allowed') {
                                if (!this.publishedImages.any(function (x) { return x === photoReference_1; })) {
                                    if (index >= 0 && index <= this.publishedImages.length) {
                                        temp = this.publishedImages[index];
                                        this.publishedImages[index] = photoReference_1;
                                        !this.isWaitingForUpload(temp);
                                    }
                                    else {
                                        this.publishedImages.push(photoReference_1);
                                    }
                                }
                                else {
                                    this.alertify.warning('This image is already added');
                                }
                            }
                            this.compensate();
                        }
                        this.isDragging = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    EditManuallyPlaceImagesModalComponent.prototype.removeOwnedImageFromAllowed = function (image) {
        this.publishedImages = this.publishedImages.filter(function (x) { return x !== image; });
        this.compensate();
    };
    EditManuallyPlaceImagesModalComponent.prototype.isWaitingForUpload = function (image) {
        if (!image)
            return false;
        return !image.includes('amazonaws');
    };
    EditManuallyPlaceImagesModalComponent.prototype.close = function () {
        if (this.actions.cancel) {
            this.actions.cancel();
        }
        this.dialogRef.close();
    };
    EditManuallyPlaceImagesModalComponent.prototype.enterImageLink = function () {
        var _this = this;
        var actions = {
            confirm: function (event, url) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log(url);
                            this.ownedImages.push({
                                url: url,
                                status: 'initial',
                            });
                            return [4 /*yield*/, this.uploadOwnedImagesToAWS()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); },
        };
        this.modalService.show({
            component: InputModalComponent,
            providers: [
                { provide: InputModalActions, useValue: actions },
                {
                    provide: InputModalData,
                    useValue: new InputModalData('Enter image link', '', null, 'OK', 'CANCEL', false),
                },
            ],
            panelClass: 'width-modal-2',
        });
    };
    EditManuallyPlaceImagesModalComponent.prototype.onImageChange = function ($event) {
        return __awaiter(this, void 0, void 0, function () {
            var i, selectedImageFile;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if ($event.srcElement.files.length > 10 || $event.srcElement.files.length + this.ownedImages.length > 10) {
                            this.alertify.warning("You can't upload more than 10 images");
                        }
                        this.selectedImageFiles = $event.srcElement.files;
                        if (!(this.selectedImageFiles && this.selectedImageFiles.length > 0)) return [3 /*break*/, 6];
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < this.selectedImageFiles.length)) return [3 /*break*/, 4];
                        if (this.ownedImages.length >= 10)
                            return [3 /*break*/, 4];
                        return [4 /*yield*/, this.imageService.compressImageFileToBase64(this.selectedImageFiles[i])];
                    case 2:
                        selectedImageFile = _a.sent();
                        this.ownedImages.push({
                            url: selectedImageFile,
                            status: 'initial',
                        });
                        _a.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4: return [4 /*yield*/, this.uploadOwnedImagesToAWS()];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        $event.srcElement.value = '';
                        return [2 /*return*/];
                }
            });
        });
    };
    EditManuallyPlaceImagesModalComponent.prototype.restoreItemStyle = function () {
        this.dropTargets.forEach(function (x) {
            x.style.border = 'none';
        });
    };
    EditManuallyPlaceImagesModalComponent.prototype.buildImages = function () {
        this.publishedImages = [];
        this.ownedImages = [];
        var allowedPhotos = clone(this.place.allowedGooglePhotos) || [];
        if (this.place.cover && this.place.cover.source) {
            allowedPhotos[0] = this.place.cover.source;
        }
        if (this.place.allowedGooglePhotos && this.place.allowedGooglePhotos.length >= 0) {
            var images = this.publishedImages.concat(allowedPhotos);
            this.publishedImages = images.slice(0, this.totalImageCountThatSysAdminSet);
        }
        if (this.place.ownedPhotos && this.place.ownedPhotos.length >= 0) {
            this.ownedImages = this.place.ownedPhotos.map(function (x) {
                return { url: x, status: 'initial' };
            });
        }
    };
    EditManuallyPlaceImagesModalComponent.prototype.compensate = function () {
        if (this.publishedImages && this.publishedImages.length >= 0) {
            this.compensateForPublished = [];
            for (var i = 0; i < this.totalImageCountThatSysAdminSet - this.publishedImages.length; i++) {
                this.compensateForPublished.push({});
            }
        }
    };
    EditManuallyPlaceImagesModalComponent.prototype.myWait = function (milSeconds) {
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                resolve(null);
            }, milSeconds);
        });
    };
    return EditManuallyPlaceImagesModalComponent;
}(BaseComponent));
export { EditManuallyPlaceImagesModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/edit.manually.place.images.modal/edit.manually.place.images.modal.component.ts.pre-build-optimizer.js